(() => {
  const globalKey = '__ferrocalmCartDeliveryCountdown';
  const selector = '[data-cart-delivery-countdown]';
  const timeZone = 'Europe/London';

  if (window[globalKey]) {
    window[globalKey].init(document);
    return;
  }

  const instances = new WeakMap();

  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone,
    weekday: 'short',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
  });

  function getZonedParts(date) {
    const values = {};

    formatter.formatToParts(date).forEach((part) => {
      if (part.type !== 'literal') {
        values[part.type] = part.value;
      }
    });

    return {
      year: Number(values.year),
      month: Number(values.month),
      day: Number(values.day),
      hour: Number(values.hour),
      minute: Number(values.minute),
      second: Number(values.second),
      weekday: values.weekday
    };
  }

  function getTimeZoneOffset(date) {
    const parts = getZonedParts(date);
    const zonedAsUtc = Date.UTC(
      parts.year,
      parts.month - 1,
      parts.day,
      parts.hour,
      parts.minute,
      parts.second
    );

    return zonedAsUtc - date.getTime();
  }

  function getLocalTimeAsUtc(parts) {
    const utcGuess = Date.UTC(
      parts.year,
      parts.month - 1,
      parts.day,
      parts.hour,
      parts.minute,
      parts.second
    );

    return utcGuess - getTimeZoneOffset(new Date(utcGuess));
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function formatRemaining(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  function render(element) {
    const messageElement = element.querySelector('[data-cart-delivery-countdown-message]');

    if (!messageElement) {
      return;
    }

    const now = new Date();
    const localNow = getZonedParts(now);
    const cutoffHour = Math.min(
      23,
      Math.max(0, Number(element.dataset.cutoffHour || 14))
    );
    const cutoffMinute = Math.min(
      59,
      Math.max(0, Number(element.dataset.cutoffMinute || 0))
    );
    const currentSeconds =
      localNow.hour * 3600 +
      localNow.minute * 60 +
      localNow.second;
    const cutoffSeconds = cutoffHour * 3600 + cutoffMinute * 60;
    const isWeekend =
      localNow.weekday === 'Sat' || localNow.weekday === 'Sun';

    let message = element.dataset.afterCutoffMessage;

    if (isWeekend) {
      message = element.dataset.weekendMessage;
    } else if (currentSeconds < cutoffSeconds) {
      const cutoffTimestamp = getLocalTimeAsUtc({
        year: localNow.year,
        month: localNow.month,
        day: localNow.day,
        hour: cutoffHour,
        minute: cutoffMinute,
        second: 0
      });

      const remainingSeconds = Math.max(
        0,
        Math.floor((cutoffTimestamp - now.getTime()) / 1000)
      );

      if (remainingSeconds > 0) {
        message = element.dataset.activeMessage.replace(
          /\[HH:MM:SS\]/g,
          formatRemaining(remainingSeconds)
        );
      }
    }

    messageElement.textContent = message;
  }

  function init(root) {
    const elements = [];

    if (root && root.matches && root.matches(selector)) {
      elements.push(root);
    }

    if (root && root.querySelectorAll) {
      elements.push(...root.querySelectorAll(selector));
    }

    elements.forEach((element) => {
      if (instances.has(element)) {
        return;
      }

      render(element);

      const timer = window.setInterval(() => {
        render(element);
      }, 1000);

      instances.set(element, timer);
    });
  }

  function cleanup(root) {
    if (!root || root.nodeType !== 1) {
      return;
    }

    const elements = [];

    if (root.matches && root.matches(selector)) {
      elements.push(root);
    }

    if (root.querySelectorAll) {
      elements.push(...root.querySelectorAll(selector));
    }

    elements.forEach((element) => {
      const timer = instances.get(element);

      if (timer) {
        window.clearInterval(timer);
        instances.delete(element);
      }
    });
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.removedNodes.forEach(cleanup);
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          init(node);
        }
      });
    });
  });

  const controller = { init };
  window[globalKey] = controller;

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), {
      once: true
    });
  } else {
    init(document);
  }
})();
